import { Component } from '@angular/core';

import { AboutPage } from '../about/about';
import { ContactPage } from '../contact/contact';
import { HomePage } from '../home/home';
import { ServicesPage} from '../services/services';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  tab1Root = HomePage;
  tab2Root = ServicesPage;
  tab3Root = ContactPage;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts